import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {RolesEnum} from '../core/security/roles.enum';
import {ModulesEnum} from '../core/security/modules.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {ListComponent} from './list/list.component';

export const routes: Routes = [
  {
    path: 'list',
    component: ListComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.DownloadsGroup,
      package: ModulesEnum.DownloadsModule,
      permissions: [RolesEnum.Any],
      animation: 'main',
      meta: {
        title: 'Downloads',
        override: true,
        description: 'Available Downloads',
        inSideMenu: true,
        iconClass: 'download',
        iconClassCode: 'phone_iphone',
      }
    }
  },
];
